"use strict";
var Observable_1 = require("../../Observable");
var single_1 = require("../../operator/single");
Observable_1.Observable.prototype.single = single_1.single;
//# sourceMappingURL=single.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/single.js
 ** module id = 389
 ** module chunks = 1
 **/